export default {
  methods: {
    sortDates(a, b) {
      {
        const dateA = new Date(a).getTime();
        const dateB = new Date(b).getTime();
        if (dateA > dateB) return 1;
        if (dateA < dateB) return -1;
        return 0;
      }
    },
    sortTranslatedObjects(a, b) {
      // czy a i b są obiektami typu {pl: 'polski', en: 'english'}
      if (Object.keys(a).length > 0 && Object.keys(b).length > 0) {
        const aLocale = a[this.$i18n.locale];
        const bLocale = b[this.$i18n.locale];
        // czy wartości pod kluczami pl/en w obydwóch obiektach nie są nullami
        if (aLocale && bLocale) {
          return aLocale.localeCompare(bLocale, this.$i18n.locale, {
            sensitivity: "base",
            ignorePunctuation: true
          });
          // jedna z wartości aLocale/bLocale lub obydwie wartości są nullem
        } else {
          if (aLocale) {
            return -1;
          }
          if (bLocale) {
            return 1;
          }
          // aLocale && bLocale = null
          return 0;
        }
        // żadna z wartości nie jest obiektem
      } else {
        if (Object.keys(a).length > 0) {
          return -1;
        }
        if (Object.keys(b).length > 0) {
          return 1;
        }
        return 0;
      }
    }
  }
};
